module.exports = __webpack_public_path__ + "static/hero_v4-optimized-bae8edd1bd499f78f3059859f0790098.mp4";